export enum TariffPrivacyStatus {
  PUBLIC_ADVANCE = 'PUBLIC_ADVANCE',
  PUBLIC_BASIC = 'PUBLIC_BASIC',
  PRIVATE = 'PRIVATE'
}
